"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/prop-types */
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var hooks_1 = require("@rainbow-modules/hooks");
var UniversalPicker_1 = __importDefault(require("../UniversalPicker"));
var defaultItem_1 = __importDefault(require("./defaultItem"));
var styled_1 = require("./styled");
function UniversalPickerOption(props) {
    var component = props.component, id = props.id, className = props.className, style = props.style, name = props.name, rest = __rest(props, ["component", "id", "className", "style", "name"]);
    var _a = react_1.useContext(UniversalPicker_1.default.context) || {}, onChange = _a.onChange, ariaDescribedby = _a.ariaDescribedby, groupName = _a.groupName, value = _a.value, multiple = _a.multiple, context = __rest(_a, ["onChange", "ariaDescribedby", "groupName", "value", "multiple"]);
    var disabled = rest.disabled;
    var _b = react_1.useState(false), isFocused = _b[0], setFocused = _b[1];
    var _c = react_1.useState(false), isHover = _c[0], setHover = _c[1];
    var type = multiple ? 'checkbox' : 'radio';
    var inputId = hooks_1.useUniqueIdentifier('universal-picker_item');
    var isSelected = function () {
        if (multiple) {
            return Array.isArray(value) && value.includes(name);
        }
        return typeof value === 'string' && name === value;
    };
    var Item = component || defaultItem_1.default;
    return (react_1.default.createElement(styled_1.StyledContainer, { className: className, style: style, id: id },
        react_1.default.createElement(styled_1.StyledInput, { as: "input", type: type, id: inputId, name: groupName, checked: isSelected(), "aria-describedby": ariaDescribedby, onChange: function (event) { return onChange(name, event.target.checked); }, disabled: disabled, onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); } }),
        react_1.default.createElement(styled_1.StyledLabel, { htmlFor: inputId, onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } },
            react_1.default.createElement(Item, __assign({}, rest, context, { isSelected: isSelected(), isFocused: isFocused, isHover: isHover })))));
}
exports.default = UniversalPickerOption;
UniversalPickerOption.propTypes = {
    /** Functional component or class that will be rendered with the props:
     * name, disabled, multiple, groupName, value and the state isSelected and isFocused. */
    component: prop_types_1.default.elementType,
    /** It is a unique value that identifies the picker option. */
    name: prop_types_1.default.string,
    /** Specifies that an UniversalPickerItem element should be disabled.
     * This value defaults to false. */
    disabled: prop_types_1.default.bool,
    /** The id of the outer element. */
    id: prop_types_1.default.string,
    /** The class name of the root element. */
    className: prop_types_1.default.string,
    /** It is an object with custom style applied to the root element. */
    style: prop_types_1.default.object,
    /**
     * This prop that should not be visible in the documentation.
     * @ignore
     */
    children: prop_types_1.default.oneOfType([
        prop_types_1.default.arrayOf(prop_types_1.default.node),
        prop_types_1.default.node,
        prop_types_1.default.object,
    ]),
};
UniversalPickerOption.defaultProps = {
    component: undefined,
    name: undefined,
    disabled: false,
    id: undefined,
    className: undefined,
    style: undefined,
    children: [],
};
//# sourceMappingURL=index.js.map